"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractFactory_1 = require("./AbstractFactory");
class AbstractModelFactory extends AbstractFactory_1.AbstractFactory {
}
exports.AbstractModelFactory = AbstractModelFactory;
//# sourceMappingURL=AbstractModelFactory.js.map